import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  const prev = el?.getAttribute("content");
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
  return () => { if (prev != null) el.setAttribute("content", prev); else el.remove(); };
};

export const useSeo = ({ title, description, image, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const undo = [
      setMeta("description", description),
      setMeta("og:title", title, "property"),
      setMeta("og:description", description, "property"),
      ...(image ? [setMeta("og:image", image, "property")] : []),
    ];
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { document.title = prevTitle; undo.forEach((u) => u()); script?.remove(); };
  }, [title, description, image, jsonLd]);
};
